// extracted by mini-css-extract-plugin
export default {"detailsHeader":"src-client-components-SapiSubscriptionModule-components-SubscriptionDetails-DetailsHeader-styles-___default__detailsHeader___qCwVX"};